import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

const ResponsiveImage = ({ 
  imagePath, 
  leftRightPadding = 0, 
  topBottomPadding = 0, 
  headerCompensate = 0, 
  angularScope 
}) => {
  const imageRef = useRef(null);

  useEffect(() => {
    const handleImageLoad = () => {
      // notify angular if needed
      if (angularScope) {
        angularScope.$broadcast('previewLoaded', { isImage: true });
      }
    };

    const img = imageRef.current;
    if (!img) return;

    // check if image is already loaded
    if (img.complete) {
      handleImageLoad();
    } else {
      img.addEventListener('load', handleImageLoad);
    }

    return () => {
      img && img.removeEventListener('load', handleImageLoad);
    };
  }, [imagePath, angularScope]);

  return (
    <ImageContainer 
      leftRightPadding={leftRightPadding} 
      topBottomPadding={topBottomPadding} 
      headerCompensate={headerCompensate}
    >
      <StyledImage 
        alt="Preview" 
        className="image-preview-img" 
        ref={imageRef} 
        src={imagePath} 
      />
    </ImageContainer>
  );
};

const ImageContainer = styled.div`
  position: relative;
  width: calc(100% - ${props => props.leftRightPadding}px);
  height: calc(100% - ${props => props.topBottomPadding}px);
  margin: ${props => props.topBottomPadding / 2}px ${props => props.leftRightPadding / 2}px;
  transform: translateY(${props => -props.headerCompensate}px);
  overflow: hidden;
`;

const StyledImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export default ResponsiveImage;